import { FC } from 'react';
import styled from 'styled-components';

export interface IAchievementBadge {
  image: string;
  title: string;
}

const Image = styled.img`
  display: block;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
`;

const AchievementBadge: FC<IAchievementBadge> = ({ image, title }) => {
  if (image == '') {
    return <div>{title}</div>;
  } else {
    return <Image src={image} alt={title} />;
  }
};

export default AchievementBadge;
